<template>
  <b-modal id="bv-modal-advertising" hide-footer size="lg">
    <template #modal-header>
      <h4>{{ $t("show_advertising") }}</h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('bv-modal-advertising')"
      >
        <i class="fas fa-times"></i>
      </b-button>
    </template>
    <b-form class="auth-register-form mb-4">
      <b-row>
        <b-col :xs="12" :sm="12" :md="12" :lg="4" class="text-center">
          <div
            style="cursor: pointer"
            id="pick-image"
            class="table-text mt-md-4"
          >
            <b-avatar button @click="previewImagen(preview)" rounded="sm" :src="preview" size="190px"> </b-avatar
            >
            <!-- <br />
            <small>{{ $t("selected-image") }}</small
            ><br /> -->
          </div>
          <!-- <avatar-cropper
            :upload-handler="selectedFile"
            @changed="setFileName"
            trigger="#pick-image"
            :labels="{
              submit: $t('accept'),
              cancel: $t('cancel'),
            }"
            :cropper-options="{
              aspectRatio: 1,
              autoCropArea: 1,
              viewMode: 1,
              movable: false,
              zoomable: false,
            }"
          /> -->
        </b-col>
        <!-- TITLE -->
        <b-col :xs="12" :sm="12" :md="12" :lg="8">
          <b-row class="table-text">
            <b-col :md="4">
              <strong>
                {{ $t("title") }}
              </strong>
            </b-col>
            <b-col :md="8">
              {{ data.title }}
            </b-col>

            <!-- TYPE -->
            <b-col :md="4">
              <strong>
                {{ $t("type") }}
              </strong>
            </b-col>
            <b-col :md="8">
              {{ data.advertising_type.name }}
            </b-col>

            <!-- RESUMEN -->
            <b-col :md="4">
              <strong>
                {{ $t("remumen") }}
              </strong>
            </b-col>
            <b-col :md="8">
              {{ data.resume }}
            </b-col>

            <!-- START_DATE -->
            <b-col :md="4">
              <strong>
                {{ $t("start-date") }}
              </strong>
            </b-col>
            <b-col :md="8">
              {{ moment(data.start_date).format('DD-MM-YYYY HH:mm') }} hrs.
            </b-col>

            <!-- END_DATE -->
            <b-col :md="4">
              <strong>
                {{ $t("end-data") }}
              </strong>
            </b-col>
            <b-col :md="8">
              {{ moment(data.end_date).format('DD-MM-YYYY HH:mm') }} hrs.
            </b-col>

            <!-- NVIEWS -->
            <b-col :md="4">
              <strong>
                {{ $t("nviews") }}
              </strong>
            </b-col>
            <b-col :md="8">
              {{ data.number_views }}
            </b-col>

            <!-- PPV -->
            <b-col :md="4">
              <strong>
                {{ $t("ppv") }}
              </strong>
            </b-col>
            <b-col :md="8">
              {{ data.ppv_currency.iso }} {{ data.price_per_view }}
            </b-col>

            <!-- INVESTMENT -->
            <b-col :md="4">
              <strong>
                {{ $t("investment") }}
              </strong>
            </b-col>
            <b-col :md="8">
              {{ data.investment_currency.iso }}
              {{ data.investment }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <template #modal-footer>
      <!-- <b-button size="sm" variant="primary" @click="onSubmit()">
        {{ $t("save") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        @click="$bvModal.hide('bv-modal-advertising')"
      >
        {{ $t("close") }}
      </b-button> -->
    </template>
  </b-modal>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import helpers from "@/services/helpers";
import { mapActions, mapGetters } from "vuex";
import { myRendeImage } from "@/directives/render-Image";
import moment from 'moment'
export default {
  mixins: [myRendeImage],
  components: {
    AvatarCropper,
  },
  mounted() {
    this.getCurrency();
    this.getTypeAdvertising();
  },
  data() {
    return {
      data: {
        id: "",
        title: "",
        advertising_type: "",
        resumen: "",
        start_date: "",
        end_date: "",
        nviews: "",
        ppv: "",
        ppv_currency: "",
        investment: "",
        investment_currency: "",
      },
      preview: "",
      fileSelected: "",
      moment
    };
  },
  methods: {
    ...mapActions({
      createOrUpdate: "advertising/createOrUpdateService",
      getCurrency: "config/getCurrency",
      getTypeAdvertising: "config/getTypeAdvertising",
    }),
    showModal(item) {
      this.formReset();
      this.preview = require("@/assets/img/brand/no-image.jpg");
      if (item) {
        this.data = item;
        this.preview = item.image
          ? this.imageData(item.image)
          : require("@/assets/img/brand/no-image.jpg");
      }
      this.fileSelected = null;

      this.$bvModal.show("bv-modal-advertising");
    },
    setFileName(file) {
      this.fileSelected = file;
      this.data.image = file;
    },
    selectedFile(cropper) {
      const dataUrl = cropper
        .getCroppedCanvas()
        .toDataURL(this.fileSelected.type);
      const file = helpers.dataURLtoFile(dataUrl, this.fileSelected.name);
      this.preview = dataUrl;
      this.data.image = file;
    },
    formReset() {
      this.data = {
        id: null,
        title: null,
        resumen: null,
        start_date: null,
        end_date: null,
        nviews: null,
        ppv: null,
        ppv_currency: null,
        investment: null,
        investment_currency: null,
      };
    },
    previewImagen(image) {
      this.$viewerApi({
        images: [image],
      });
    },
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        try {
          const res = await this.createOrUpdate(this.data);
          if (res.status === 200) {
            this.$toast.success(res.data.description, {
              position: "top-right",
            });
          }
          this.$bvModal.hide("bv-modal-advertising");
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      currency: "config/currency",
      advertising: "config/advertising",
    }),
  },
};
</script>

<style>
.vs__selected {
  color: gray;
}
.vs__dropdown-toggle {
  border: none;
}
</style>
